<router-outlet *ngIf="status" ></router-outlet>

<div class="offline" *ngIf="!status" >
    <i class="material-icons">wifi_off</i>
    <div id="headingone">Your Connection was Offline.</div>
    Please check your Wifi Connection.
</div>